
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';

interface Recipe {
  id: number;
  name: string;
  ingredients: string[];
  instructions: string[];
}

const Recipes: React.FC = () => {
  const [recipes, setRecipes] = useState<Recipe[]>([]);

  useEffect(() => {
    axios.get('http://localhost:8000/api/recipes')
      .then(response => {
        const parsedRecipes = response.data.map((recipe: any) => ({
          ...recipe,
          ingredients: JSON.parse(recipe.ingredients),
          instructions: JSON.parse(recipe.instructions),
        }));
        setRecipes(parsedRecipes);
      })
      .catch(error => console.error('Error fetching recipes:', error));
  }, []);

  const handleDelete = (id: number) => {
    axios.delete(`http://localhost:8000/api/recipes/${id}`)
      .then(response => {
        console.log(response.data.message);
        setRecipes(recipes.filter(recipe => recipe.id !== id));
      })
      .catch(error => console.error('Error deleting recipe:', error));
  };

  return (
    <div className="container mt-5">
      <h1 className="mb-4">All Recipes</h1>
      <div className="row">
        {recipes.map(recipe => (
          <div key={recipe.id} className="col-md-4 mb-4">
            <div className="card h-100">
              <div className="card-body">
                <h5 className="card-title">
                  <Link to={`/recipe/${recipe.id}`}>{recipe.name}</Link>
                </h5>
                <button className="btn btn-danger btn-sm" onClick={() => handleDelete(recipe.id)}>Delete</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Recipes;
